"use strict";

(function () {
  var COOKIE_NAME = "aarp_visitor";
  var COOKIE_DAYS = 30;
  var DISCOUNT_CODE = String(window.AARP_DISCOUNT_CODE || "AARPSAVINGS").trim().toLowerCase();
  var ATTR_KEY = "AARP Member Number";
  var FLASH_KEY = "aarp_cart_message";

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function setAarpCookie() {
    if (typeof Cookies !== "undefined" && Cookies.set) {
      Cookies.set(COOKIE_NAME, "1", { expires: COOKIE_DAYS, path: "/" });
      return;
    }
    var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = COOKIE_NAME + "=1; expires=" + expires + "; path=/";
  }

  function hasAarpCookie() {
    if (typeof Cookies !== "undefined" && Cookies.get) {
      return Cookies.get(COOKIE_NAME) === "1";
    }
    return document.cookie.split("; ").some(function (part) {
      return part === COOKIE_NAME + "=1";
    });
  }

  function isAarpVisitor() {
    return getQueryParam("ref") === "aarp" || hasAarpCookie();
  }

  function isAarpLandingPage() {
    var body = document.body;
    if (!body || !body.classList) return false;
    return body.classList.contains("page-aarp") || body.classList.contains("aarp-page");
  }

  function captureRef() {
    if (getQueryParam("ref") === "aarp" || isAarpLandingPage()) {
      setAarpCookie();
    }
  }

  function isB2bCustomer() {
    return document.documentElement.getAttribute("data-customer-b2b") === "true";
  }

  function getVerifyUrl() {
    var url = (window.AARP_VERIFY_URL || "").trim();
    return url || "";
  }

  function showCartField() {
    var field = document.querySelector("[data-aarp-cart-field]");
    if (!field) return;
    if (isB2bCustomer()) return;
    if (!isAarpVisitor()) return;
    field.hidden = false;
    field.removeAttribute("hidden");
    field.classList.add("is-visible");
  }

  function setMessage(el, text, isError) {
    if (!el) return;
    el.textContent = text || "";
    el.hidden = !text;
    el.classList.toggle("is-error", !!isError);
  }

  function resetButton(button) {
    if (!button) return;
    button.disabled = false;
    button.removeAttribute("aria-busy");
  }

  function buildVerifyBody(trimmed) {
    if (trimmed.indexOf("@") !== -1) {
      return { email: trimmed };
    }
    return { memberNumber: trimmed };
  }

  function messageForStatus(status) {
    if (status === 1) {
      return "We could not find an active AARP membership for that number or email.";
    }
    if (status === 2) {
      return "This AARP membership is expired or needs renewal.";
    }
    return "Unable to verify AARP membership. Please try again.";
  }

  function storeFlash(text, isError) {
    try {
      sessionStorage.setItem(FLASH_KEY, JSON.stringify({ text: text, isError: !!isError }));
    } catch (e) {}
  }

  function showFlash(messageEl) {
    try {
      var raw = sessionStorage.getItem(FLASH_KEY);
      if (!raw) return;
      sessionStorage.removeItem(FLASH_KEY);
      var flash = JSON.parse(raw);
      setMessage(messageEl, flash.text, flash.isError);
    } catch (e) {}
  }

  function isCodeApplicable(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code).toLowerCase() === DISCOUNT_CODE) {
        return codes[i].applicable === true;
      }
    }
    return false;
  }

  function saveAttributeAndApplyDiscount(trimmed) {
    var attributes = {};
    attributes[ATTR_KEY] = trimmed;

    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ attributes: attributes, discount: DISCOUNT_CODE })
    })
      .then(function (response) {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function (cart) {
        if (isCodeApplicable(cart)) {
          storeFlash("AARP membership verified. Your AARP discount has been applied.", false);
        } else {
          storeFlash(
            "AARP membership verified. Our current sale discount is already applied to your cart and can't be combined with the AARP discount.",
            false
          );
        }
        window.location.reload();
      });
  }

  function verifyMembership(trimmed) {
    var verifyUrl = getVerifyUrl();
    if (!verifyUrl) {
      return Promise.reject({ type: "misconfigured" });
    }

    return fetch(verifyUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(buildVerifyBody(trimmed))
    }).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, status: response.status, data: data || {} };
      });
    });
  }

  function applyAarpDiscount(value, button, messageEl) {
    var trimmed = (value || "").trim();
    if (!trimmed) {
      setMessage(messageEl, "Please enter your AARP member number or email.", true);
      return;
    }

    setMessage(messageEl, "");
    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    }

    verifyMembership(trimmed)
      .then(function (result) {
        if (!result.ok || result.data.error) {
          throw { type: "lookup_failed" };
        }

        var status = Number(result.data.status);
        if (status !== 0 && result.data.active !== true) {
          setMessage(messageEl, messageForStatus(status), true);
          resetButton(button);
          return null;
        }

        return saveAttributeAndApplyDiscount(trimmed);
      })
      .catch(function (err) {
        if (err && err.type === "misconfigured") {
          setMessage(
            messageEl,
            "AARP verification is not configured yet. Please try again later.",
            true
          );
        } else {
          setMessage(messageEl, "Something went wrong. Please try again.", true);
        }
        resetButton(button);
      });
  }

  function bindCartApply() {
    var form = document.querySelector("[data-aarp-cart-form]");
    if (!form) return;

    var input = form.querySelector("[data-aarp-member-input]");
    var button = form.querySelector("[data-aarp-apply]");
    var messageEl = form.querySelector("[data-aarp-message]");

    showFlash(messageEl);

    function handleApply(event) {
      if (event) event.preventDefault();
      applyAarpDiscount(input && input.value, button, messageEl);
    }

    if (button) {
      button.addEventListener("click", handleApply);
    }

    if (input) {
      input.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          handleApply(event);
        }
      });
    }
  }

  function bindCheckoutReminder() {
    var field = document.querySelector("[data-aarp-cart-field]");
    if (!field || field.hidden || field.hasAttribute("data-aarp-verified")) return;

    var input = field.querySelector("[data-aarp-member-input]");
    var messageEl = field.querySelector("[data-aarp-message]");
    var reminded = false;

    document.addEventListener(
      "click",
      function (event) {
        if (reminded || !event.target.closest) return;
        if (!event.target.closest("#checkout")) return;

        reminded = true;
        event.preventDefault();
        event.stopImmediatePropagation();
        setMessage(
          messageEl,
          "You haven't applied your AARP discount. Enter your AARP member number or email above and click Apply, or click Checkout again to continue without it.",
          true
        );
        field.scrollIntoView({ block: "center", behavior: "smooth" });
        if (input) input.focus({ preventScroll: true });
      },
      true
    );
  }

  function init() {
    captureRef();
    showCartField();
    bindCartApply();
    bindCheckoutReminder();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
